import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/142/components/features/cases/OldComponents/cases/rukami/index.js");
